import type { ApiError } from '../../api/api-error';
import { Button } from '../../components/Button';
import { Icon } from '../../components/Icon';
import { useI18n } from '../../i18n/i18n-context';
import { rich } from '../../i18n/rich';

interface CreditLimitNoticeProps {
  /** The CREDIT_LIMIT_REACHED error, which carries today's usage. */
  readonly error: ApiError;
  /** Opens the plans; omitted when there's no bigger plan to offer. */
  readonly onSeePlans?: () => void;
}

export function CreditLimitNotice({ error, onSeePlans }: CreditLimitNoticeProps) {
  const { t, format, describeError } = useI18n();
  const { usage } = error;
  return (
    <div
      className="empty-state empty-state--warning empty-state--credit-limit"
      data-level={usage && usage.remaining > 0 ? 'low' : 'empty'}
    >
      <span className="empty-icon" aria-hidden="true">
        <Icon name="clock" />
      </span>
      <h3 className="empty-title">
        {usage && usage.remaining > 0 ? t.creditLimit.notEnough : t.creditLimit.usedUp}
      </h3>
      <p className="empty-description">
        {describeError(error)}
        {usage && (
          <>
            {' '}
            {rich(t.creditLimit.resetsAt, {
              time: <span className="limit-countdown">{format.resetTime(usage.resetsAt)}</span>,
            })}
          </>
        )}
      </p>
      {onSeePlans && (
        <Button variant="primary" className="empty-action" onClick={onSeePlans}>
          {t.creditLimit.getMore}
        </Button>
      )}
    </div>
  );
}
